module.exports = __webpack_public_path__ + "d56cb18fe3da6173a850e568998cab98.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-2.png
// module id = 2494
// module chunks = 0